import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import AdminHeader from './../header/adminheader';

export default class Dashboard extends Component {
  showAdminHeader = () => {
    if(this.props.user){
        return <AdminHeader user={this.props.user} />
    }
  }

  render() {
    let msgToShow = '';
    return (
      <Row>
        <Col>
            <h2>Dashboard</h2>
            <h3>{msgToShow}</h3>
            {this.showAdminHeader()}
        </Col>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.js